import { MiStackedTypography } from "@miplatform/components";
import { TYPOGRAPHY_VARIANTS } from "@miplatform/constants";
import { useTheme } from "@mui/material";

export const Info = ({
  text = "",
  subtext = "",
  maxWidth = 120,
  descriptionColor,
}: {
  text?: string;
  subtext?: string;
  maxWidth?: number;
  descriptionColor?: string;
}) => {
  const theme = useTheme();

  return (
    <MiStackedTypography
      title={text}
      titleFontSize={11}
      titleProps={{
        variant: TYPOGRAPHY_VARIANTS.BODY2,
      }}
      description={subtext}
      descriptionFontSize={12}
      descriptionProps={{
        color: descriptionColor ?? theme.palette.text.primary,
        maxWidth,
        fontWeight: theme.fontWeight.semiBold,
      }}
    />
  );
};
